import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

let swiper;
const breakpoint = window.matchMedia('(min-width:769px)');
const changeTabButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.js-openTab');

export function initBreakpointCheckerTabelement() {

  if (breakpoint.matches) {
    if (swiper !== undefined) {
      swiper.destroy(true, true);
    }
    return;
  } else {
    if (document.querySelectorAll('.js-swiper').length) {
      swiper = new Swiper('.js-swiper', {
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        mousewheel: true,
        keyboard: true,
      });

      swiper.on('slideChangeTransitionEnd', function (event) {
        const activeSlide = changeTabButtons[event.activeIndex];
        if (activeSlide) {
          openTab(activeSlide.dataset.tabId || '');
        }
      });
    }
  }
}

function openTab(contentId: string) {
  const tabContentElements = document.querySelectorAll('.tabcontent');

  tabContentElements.forEach((element) => {
    element.classList.remove('tabcontent--active');
  });

  const tabContent = document.querySelector(`#${contentId}`);
  if (tabContent) {
    tabContent.classList.add('tabcontent--active');
  }
}

changeTabButtons.forEach((tabElement, index) => {
  if (index === 0) {
    openTab(tabElement.dataset.tabId || '');
  }
  tabElement.addEventListener('click', () => {
    openTab(tabElement.dataset.tabId || '');
  });
});

const tablinks = document.querySelectorAll('.tab-scroll-links');
tablinks.forEach((tabLink, index) => {

  if (index === 0) {
    tabLink.classList.add('active');
  }

  tabLink.addEventListener('click', () => {
    tablinks.forEach((restLink) => {
      restLink.classList.remove('active');
    });
    tabLink.classList.add('active');
  });
});

initBreakpointCheckerTabelement();
breakpoint.addEventListener('change', initBreakpointCheckerTabelement);
document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('.js-jobGeneratorButton') as HTMLElement | null;
  const wrapper = document.querySelector('.js-cardWrapper') as HTMLElement | null;

  if (!button || !wrapper) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          button.classList.remove('remove');
          button.classList.add('tabcontent__wrapperButton--fixed');
        } else {
          button.classList.add('remove');
          setTimeout(() => {button.classList.remove('tabcontent__wrapperButton--fixed'); }, 750);
        }
      });
    },
    {
      threshold: 0.02,
    },
  );

  observer.observe(wrapper);
});

